import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import "./Loading.css";
import loadingGif from "../assets/loading.gif";

const FADE_DURATION_MS = 420;

const Loading = ({ active = true }) => {
  const [isRendered, setIsRendered] = useState(Boolean(active));
  const [isFadingOut, setIsFadingOut] = useState(false);

  useEffect(() => {
    let timer = null;

    if (active) {
      setIsRendered(true);
      timer = window.setTimeout(() => {
        setIsFadingOut(false);
      }, 16);
    } else {
      setIsFadingOut(true);
      timer = window.setTimeout(() => {
        setIsRendered(false);
      }, FADE_DURATION_MS);
    }

    return () => {
      if (timer) window.clearTimeout(timer);
    };
  }, [active]);

  if (!isRendered) return null;

  if (typeof document === "undefined" || !document.body) {
    return null;
  }

  return createPortal(
    <div
      className={`loading-container ${isFadingOut ? "loading-container-fade-out" : ""}`}
      aria-hidden={!active}
    >
      <img src={loadingGif} alt="Loading..." className="loading-gif" />
      <p>Loading, please wait...</p>
    </div>,
    document.body
  );
};

export default Loading;
